import * as actionTypes from '../actions';

import { addItemInListOfItems, deleteItemByIdInListOfItems, updateItemInListOfItems } from "../../helpers";


const initialState = {
    tables: [],

    getTablesLoading: false,
    getTablesError: null,

    addTableLoading: false,
    addTableError: null,

    deleteTableLoading: false,
    deleteTableError: null,

    updateTableLoading: false,
    updateTableError: null,

    tableTypes: [],

    getTableTypesLoading: false,
    getTableTypesError: null,

    tableLinks: [],

    getTableLinksLoading: false,
    getTableLinksError: null,

    addTableLinkLoading: false,
    addTableLinkError: null,

    deleteTableLinkLoading: false,
    deleteTableLinkError: null,

    updateTableLinkLoading: false,
    updateTableLinkError: null,
};

const tablesReducer = (state = initialState, action) => {
    switch (action.type) {

        // GET TABLES
        case actionTypes.GET_TABLES_REQUEST:
            return {
                ...state,
                getTablesLoading: action.loading
            };
        case actionTypes.GET_TABLES_SUCCESS:
            return {
                ...state,
                getTablesLoading: action.loading,
                getTablesError: action.error,
                tables: action.tables
            };
        case actionTypes.GET_TABLES_ERROR:
            return {
                ...state,
                getTablesLoading: action.loading,
                getTablesError: action.error
            };

        // ADD TABLE
        case actionTypes.ADD_TABLE_REQUEST:
            return {
                ...state,
                addTableLoading: action.loading
            };
        case actionTypes.ADD_TABLE_SUCCESS:
            return {
                ...state,
                addTableLoading: action.loading,
                addTableError: action.error,
                tables: addItemInListOfItems(state.tables, action.table)
            };
        case actionTypes.ADD_TABLE_ERROR:
            return {
                ...state,
                addTableLoading: action.loading,
                addTableError: action.error
            };

        // DELETE TABLE
        case actionTypes.DELETE_TABLE_REQUEST:
            return {
                ...state,
                deleteTableLoading: action.loading
            };
        case actionTypes.DELETE_TABLE_SUCCESS:
            return {
                ...state,
                deleteTableLoading: action.loading,
                deleteTableError: action.error,
                tables: deleteItemByIdInListOfItems(state.tables, action.tableId)
            };
        case actionTypes.DELETE_TABLE_ERROR:
            return {
                ...state,
                deleteTableLoading: action.loading,
                deleteTableError: action.error
            };

        // UPDATE TABLE
        case actionTypes.UPDATE_TABLE_REQUEST:
            return {
                ...state,
                updateTableLoading: action.loading
            };
        case actionTypes.UPDATE_TABLE_SUCCESS:
            return {
                ...state,
                updateTableLoading: action.loading,
                updateTableError: action.error,
                tables: updateItemInListOfItems(state.tables, action.table)
            };
        case actionTypes.UPDATE_TABLE_ERROR:
            return {
                ...state,
                updateTableLoading: action.loading,
                updateTableError: action.error
            };


        // GET TABLELINKS
        case actionTypes.GET_TABLELINKS_REQUEST:
            return {
                ...state,
                getTableLinksLoading: action.loading
            };
        case actionTypes.GET_TABLELINKS_SUCCESS:
            return {
                ...state,
                getTableLinksLoading: action.loading,
                getTableLinksError: action.error,
                tableLinks: action.tableLinks
            };
        case actionTypes.GET_TABLELINKS_ERROR:
            return {
                ...state,
                getTableLinksLoading: action.loading,
                getTableLinksError: action.error
            };

        // ADD TABLELINK
        case actionTypes.ADD_TABLELINK_REQUEST:
            return {
                ...state,
                addTableLinkLoading: action.loading
            };
        case actionTypes.ADD_TABLELINK_SUCCESS:
            return {
                ...state,
                addTableLinkLoading: action.loading,
                addTableLinkError: action.error,
                tableLinks: addItemInListOfItems(state.tableLinks, action.tableLink)
            };
        case actionTypes.ADD_TABLELINK_ERROR:
            return {
                ...state,
                addTableLinkLoading: action.loading,
                addTableLinkError: action.error
            };

        // DELETE TABLELINK
        case actionTypes.DELETE_TABLELINK_REQUEST:
            return {
                ...state,
                deleteTableLinkLoading: action.loading
            };
        case actionTypes.DELETE_TABLELINK_SUCCESS:
            return {
                ...state,
                deleteTableLinkLoading: action.loading,
                deleteTableLinkError: action.error,
                tableLinks: deleteItemByIdInListOfItems(state.tableLinks, action.tableLinkId)
            };
        case actionTypes.DELETE_TABLELINK_ERROR:
            return {
                ...state,
                deleteTableLinkLoading: action.loading,
                deleteTableLinkError: action.error
            };

        // UPDATE TABLELINK
        case actionTypes.UPDATE_TABLELINK_REQUEST:
            return {
                ...state,
                updateTableLinkLoading: action.loading
            };
        case actionTypes.UPDATE_TABLELINK_SUCCESS:
            return {
                ...state,
                updateTableLinkLoading: action.loading,
                updateTableLinkError: action.error,
                tableLinks: updateItemInListOfItems(state.tableLinks, action.tableLink)
            };
        case actionTypes.UPDATE_TABLELINK_ERROR:
            return {
                ...state,
                updateTableLinkLoading: action.loading,
                updateTableLinkError: action.error
            };
        
        // GET TABLE TYPES
        case actionTypes.GET_TABLE_TYPES_REQUEST:
            return {
                ...state,
                getTableTypesLoading: true,
            };
        case actionTypes.GET_TABLE_TYPES_SUCCESS:
            return {
                ...state,
                getTableTypesLoading: false,
                getTableTypesError: null,
                tableTypes: action.tableTypes,
            };
        case actionTypes.GET_TABLE_TYPES_ERROR:
            return {
                ...state,
                getTableTypesLoading: false,
                getTableTypesError: action.error,
            };

        case actionTypes.SET_TABLES:
            return {
                ...state,
                tables: [...action.tables],
            };
        
        case actionTypes.SET_TABLELINKS:
            return {
                ...state,
                tableLinks: [...action.tableLinks],
            };

        default:
            return state;
    }
};

export default tablesReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/tables.js